import { forwardRef, ReactNode } from "react";

import Input, { InputProps } from "../Base/Input";
import HelperText from "../HelperText";
import Label from "../Label";

export interface FieldProps extends Omit<InputProps, "error" | "label"> {
  label: ReactNode;
  error?: boolean;
  errorMessage?: ReactNode | undefined;
  helperText?: string;
}

const InputField = forwardRef<HTMLInputElement, FieldProps>(
  ({ label, error, errorMessage = null, helperText = null, ...props }, ref) => {
    return (
      <Label content={label} block={props.block}>
        <Input {...props} error={Boolean(errorMessage || error)} ref={ref} />
        <HelperText
          content={errorMessage || helperText || ""}
          error={Boolean(errorMessage || error)}
        />
      </Label>
    );
  }
);

InputField.displayName = "InputField";

export default InputField;
